const validDateTimeComponentCombinations = require('./data/date/validDateTimeComponentCombinations.json');
const validDateTimeComponentValues = require('./data/date/validDateTimeComponentValues.json');

const isValidDate = (d) => {
    return d instanceof Date && !isNaN(d);
};

const equalsIgnoreOrder = (o1, o2) => {
    Object.keys(o2).forEach((key) => (!o2[key]) && delete o2[key]);
    o2 = Object.keys(o2);
    if (o2.length === 0) {
        return true;
    }
    return o1.sort().join() === o2.sort().join();
};

const isValidDateTimeComponentCombinations = (args) => {
    return Object.keys(validDateTimeComponentCombinations).map((e) => validDateTimeComponentCombinations[e]).some((value) => equalsIgnoreOrder(value, args));
};

const isValidDateTimeComponentValue = (values, value) => {
    return !value || values.indexOf(value) >= 0;
};

const isValidDateTimeComponentValues = (args) => {
    return Object.keys(args).every((key) => isValidDateTimeComponentValue(validDateTimeComponentValues[key], args[key]));
};

const getUTCEquivalentSanitizedDateTime = (dateTime) => {
    let sanitizedDate = new Date(dateTime);
    if (dateTime.indexOf('GMT') !== -1) {
        const offset = -Number(dateTime.substring(dateTime.indexOf('GMT') + 3, dateTime.indexOf('GMT') + 9).replace(':', ''));
        const timeZoneOffset = (Math.trunc(offset / 100) * 60 + offset % 100 - new Date().getTimezoneOffset()) * 60000;
        sanitizedDate = new Date(sanitizedDate - timeZoneOffset);
    }
    return new Date(Date.UTC(sanitizedDate.getFullYear(), sanitizedDate.getMonth(), sanitizedDate.getDate(), sanitizedDate.getHours(), sanitizedDate.getMinutes(), sanitizedDate.getSeconds()));
};

const getUTCEquivalentSanitizedDate = (date) => {
    date = date.trim();
    const dateRegex = (/^(\d{4})(-|\/)(\d{1,2})((-|\/)(\d{1,2}))?/).exec(date);
    const year = parseInt(dateRegex[1], 10);
    const month = parseInt(dateRegex[3], 10);
    const day = parseInt(dateRegex[6], 10);
    return isNaN(day) ? new Date(Date.UTC(year, month - 1)) : new Date(Date.UTC(year, month - 1, day));
};

module.exports = {isValidDate, isValidDateTimeComponentValues, isValidDateTimeComponentCombinations, getUTCEquivalentSanitizedDate, getUTCEquivalentSanitizedDateTime};
